import { Routes } from '@angular/router';

const Routing: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'coupon-performance',
  },
  {
    path: 'coupon-performance',
    pathMatch: 'full',
    loadChildren: () =>
      import('./coupon-performance/coupon-performance.module').then(
        (m) => m.CouponPerformanceModule
      ),
  },
  {
    path: 'upsell-rates',
    pathMatch: 'full',
    loadChildren: () =>
      import('./upsell-rates/upsell-rates.module').then(
        (m) => m.UpsellRatesModule
      ),
  },
  {
    path: 'pet-demographics',
    pathMatch: 'full',
    loadChildren: () =>
      import('./pet-demographics/pet-demographics.module').then(
        (m) => m.PetDemographicsModule
      ),
  },
  {
    path: 'shipments-report',
    pathMatch: 'full',
    loadChildren: () => 
            import('./orders-report/orders-report.module').then((m) => m.OrdersReportModule),
  },
  {
    path: 'support',
    pathMatch: 'full',
    loadChildren: () =>
      import('./support/support.module').then((m) => m.SupportModule),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./settings/settings.module').then((m) => m.SettingsModule),
  },
];

export { Routing };
